import { axiosInstance } from "./axiosInstance";

export const PopupNotificationServices = {
  getAll: async (filter) => {
    return await axiosInstance.get('/api/config/popup-notification/admin', { params: filter });
  },
  create: async (data) => {
    return await axiosInstance.post('/api/config/popup-notification/', data);
  },
  update: async (id, data) => {
    return await axiosInstance.post(`/api/config/popup-notification/update/${id}`, data);
  },
  delete: async (id) => {
    return await axiosInstance.delete(`/api/config/popup-notification/delete/${id}`);
  }
}